import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { modifyUaddress,getUserUaddress,modifyPayPassword } from '../../../api'


  
export default /*#__PURE__*/_defineComponent({
  __name: 'paymentSettings',
  setup(__props) {

  const layFormRef11 = ref();
 

  
  

  const address = reactive({
    uaddress: "",
    payPassword: "", 
  })

  const pay = reactive({
    oldPassword: "",
    password: "",
    confirmPassword: "", 
  })


  //添加密码
  const  addUaddress=()=>{
     if(address.uaddress.length<=6){
        layer.msg("请输入正确的U地址", { time: 1000, icon: 2 });
        return;
     }
     if(address.payPassword.length!=6){
        layer.msg("请输入您6位支付密码", { time: 1000, icon: 2 });
        return;
     } 
     modifyUaddress(JSON.stringify(address)).then((res: any) => {
        if (res != "" && res.code == 0) { 
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      }) 
  }

  const  getUserInfo=()=>{ 
      getUserUaddress().then((res: any) => {
        if (res != "" && res.code == 0) { 
            address.uaddress=res.data.uaddress;
        }
      }) 
  }

  getUserInfo();


  const  modifyPassword=()=>{
    if(pay.oldPassword.length!=6){
        layer.msg("请输入您当前使用支付密码", { time: 1000, icon: 2 });
        return;
     } 

     if(pay.password.length!=6||pay.confirmPassword.length!=6){
        layer.msg("新密码与确认密码不一致", { time: 1000, icon: 2 });
        return;
     } 

     if(pay.password!=pay.confirmPassword){
        layer.msg("新密码与确认密码不一致", { time: 1000, icon: 2 });
        return;
     } 

     modifyPayPassword(JSON.stringify(pay)).then((res: any) => {
        if (res != "" && res.code == 0) { 
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      }) 

  }
  


 

return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_card = _resolveComponent("lay-card")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!

  return (_openBlock(), _createBlock(_component_lay_row, { space: "10" }, {
    default: _withCtx(() => [
      _createVNode(_component_lay_col, {
        md: "12",
        sm: "12",
        xs: "24"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_lay_card, { title: "钱包设置" }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form, {
                model: address,
                ref_key: "layFormRef11",
                ref: layFormRef11
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_form_item, {
                    label: "U地址",
                    prop: "uaddress"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_input, {
                        modelValue: address.uaddress,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((address.uaddress) = $event)),
                        placeholder: "请输入U地址"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_form_item, {
                    label: "支付密码",
                    prop: "payPassword"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_input, {
                        modelValue: address.payPassword,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((address.payPassword) = $event)),
                        placeholder: "请输入支付密码",
                        maxlength: "6"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_button, {
                    onClick: addUaddress,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("提交")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_lay_col, {
        md: "12",
        sm: "12",
        xs: "24"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_lay_card, { title: "支付密码修改（默认密码：123456）" }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form, {
                model: pay,
                ref_key: "layFormRef11",
                ref: layFormRef11
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_form_item, {
                    label: "支付密码",
                    prop: "oldPassword"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_input, {
                        modelValue: pay.oldPassword,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((pay.oldPassword) = $event)),
                        maxlength: "6",
                        placeholder: "请输入当前使用的支付密码"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_form_item, {
                    label: "新密码",
                    prop: "password"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_input, {
                        modelValue: pay.password,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((pay.password) = $event)),
                        maxlength: "6",
                        placeholder: "请输入新支付密码"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_form_item, {
                    label: "确认密码",
                    prop: "confirmPassword"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_input, {
                        modelValue: pay.confirmPassword,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((pay.confirmPassword) = $event)),
                        maxlength: "6",
                        placeholder: "请输入再次新支付密码"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_button, {
                    onClick: modifyPassword,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("提交")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})